const asideElement = document.getElementById('cms_aside')
const bodyElement = document.getElementById('cms-body')


const _getAsideInstance = () => {
  return document.getElementById('cms_aside')
}

const _getBodyInstance = () => {
  return document.getElementById('cms-body')
}

const _getAsideOverlayInstance = () => {
  return document.getElementById('drawer-overlay')
}

const _createAsideOverlay = () => {
  const asideOverlay = document.createElement('div')
  asideOverlay.id = 'drawer-overlay'
  asideOverlay.style.zIndex = '109'
  asideOverlay.className = 'drawer-overlay'

  asideOverlay.onclick = () => {
    closeAsideMenu()
  }

  return asideOverlay
}

const openAsideMenu = () => {
  _getAsideInstance().classList.add('drawer', 'drawer-start', 'drawer-on')
  _getBodyInstance().appendChild(_createAsideOverlay())
}

const closeAsideMenu = () => {
  if (asideIsOpen()) {
    _getAsideOverlayInstance().remove()
    _getAsideInstance().classList.remove('drawer', 'drawer-start', 'drawer-on')
  }
}

const asideIsOpen = () => {
  const instance = _getAsideInstance()
  return instance ? instance.classList.contains('drawer-on') : false
}


module.exports = {
  openAsideMenu,
  closeAsideMenu,
  asideIsOpen
}
